import React, { useMemo } from 'react';
import type { EventNameNavProps } from '../components/EventNameNav';
import { EventNameNav } from '../components/EventNameNav';
import type { WebsiteHeaderLayout_PhotoMarquee } from '@shared/types/WebsiteHeaderSettings.types';
import { HeaderPhoto } from '../components/HeaderPhoto/HeaderPhoto';
import { PhotoMarquee } from '@apps/guest/packages/layout-engine/widgets/Custom/components';

interface PhotoMarqueeLayoutProps extends EventNameNavProps {
  websiteHeader: WebsiteHeaderLayout_PhotoMarquee;
  showPlaceholder?: boolean;
}

export const PhotoMarqueeLayout = (props: PhotoMarqueeLayoutProps) => {
  const { websiteHeader, showPlaceholder = false, ...restProps } = props;

  const photos = useMemo(() => {
    return websiteHeader.headerPhoto.photos?.map(photo => ({ ...photo, id: photo.id, photoUrl: photo.url })) || [];
  }, [websiteHeader]);

  return (
    <EventNameNav
      eventDisplayName={websiteHeader.eventDisplayName}
      headerTextData={websiteHeader.headerPhoto.eventName}
      {...restProps}
    >
      <HeaderPhoto
        websiteHeader={websiteHeader}
        pageSlug={restProps.pageSlug}
        pageType={restProps.page}
        showPlaceholder={showPlaceholder}
      >
        <PhotoMarquee
          photos={photos}
          showPlaceholder={showPlaceholder}
        />
      </HeaderPhoto>
    </EventNameNav>
  );
};
